import { SvgIcon, SvgIconProps } from '@mui/material'

const ArrowUp = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97982 5.64645C8.17508 5.45118 8.49167 5.45118 8.68693 5.64645L12.6869 9.64645C12.8822 9.84171 12.8822 10.1583 12.6869 10.3536C12.4917 10.5488 12.1751 10.5488 11.9798 10.3536L8.33337 6.70711L4.68693 10.3536C4.49167 10.5488 4.17508 10.5488 3.97982 10.3536C3.78456 10.1583 3.78456 9.84171 3.97982 9.64645L7.97982 5.64645Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ArrowUp
